import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/blog/store",
    data: data,
  });
};

export const GetData = async (pageNumber, limit = 15) => {
  return await Get({
    url: "/blog/show_all",
    data: {
      limit: limit,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/blog/destroy",
    data: data,
  });
};

export const Gettags = async () => {
  return await Get({
    url: "/tag/show_list",
  }).then(data => {
    return data;
  });
};
export const GetCategory = async () => {
  return await Get({
    url: "/blogcategory/show_all",
  }).then(data => {
    return data;
  });
};
export const Getoneblog = async () => {
  return await Get({
    url: "/blog/showbyslug",
  }).then(data => {
    return data;
  });
};
export const EditData = async data => {
  await Set({
    url: "/blog/update",
    data: data,
  });
};
export const GetDataCreate = async () => {
  return await Get({
    url: "/item/nes_data",
  }).then(data => {
    return data;
  });
};
